import React from 'react'

import { FeaturesSection as SharedFeaturesSection } from 'components/features-section/FeaturesSection'
import sdkIcon from 'shared/assets/icons/sdk.svg'
import rocketIcon from 'shared/assets/icons/rocket.svg'
import databaseIcon from 'shared/assets/icons/database-gradient.svg'

import type { SoundcorePageCmsContent } from 'core/services/cms/interfaces'

interface FeaturesSectionProps {
  content: SoundcorePageCmsContent['features']
}

const PILL_ICONS = [sdkIcon, rocketIcon, databaseIcon]

const FeaturesSection: React.FC<FeaturesSectionProps> = ({ content }) => {
  return (
    <SharedFeaturesSection
      title={content.title}
      features={content.blocks.map((block, index) => ({
        imageDesktop: block.imageDesktopUrl,
        imageMobile: block.imageMobileUrl,
        title: block.title,
        pillIcon: PILL_ICONS[index],
        pillText: block.pillText,
        reverse: index % 2 === 1,
        content: {
          heading: block.contentHeading,
          items: block.contentItems,
        },
      }))}
    />
  )
}

export default FeaturesSection
